import React, { memo } from "react";

import { Button, Dialog, DialogContent } from "@mui/material";
import DialogTitle from "../DialogTitle/DialogTitle";
import DialogActions from "../DialogActions/DialogActions";

import { Props } from "./interfaces";
import LoadingOverlay from "../LoadingOverlay/LoadingOverlay";

const CustomConfirmationChangesDialog = ({
  open,
  loading,
  title,
  children,
  handleCancel,
  actionsAndHandlers,
}: Props) => {
  return (
    <Dialog
      open={open}
      fullWidth
    >
      <LoadingOverlay loading={loading}>
        <DialogTitle
          title={title}
          handleClose={handleCancel}
        />
        <DialogContent>{children}</DialogContent>
        <DialogActions
          handleCancel={handleCancel}
          useGoback={true}
        >
          {actionsAndHandlers.length > 0 &&
            actionsAndHandlers.map(({ action, buttonVariant, handler, customButtonStyle, disabled }, idx) => (
              <Button
                key={idx}
                style={{ ...customButtonStyle }}
                variant={buttonVariant}
                onClick={(event) => {
                  event.preventDefault();
                  handler();
                }}
                disabled={disabled}
              >
                {action}
              </Button>
            ))}
        </DialogActions>
      </LoadingOverlay>
    </Dialog>
  );
};

export default memo(CustomConfirmationChangesDialog);
